export default "__VITE_ASSET__B4mJ5pB0__$_?format=webp__"